import { toast } from 'sonner';

/**
 * Toast notification utility hook.
 * 
 * Provides convenience functions for showing toast notifications
 * using the Sonner library.
 */

export const useToast = () => {
  return {
    success: (message: string) => toast.success(message),
    error: (message: string) => toast.error(message),
    info: (message: string) => toast.info(message),
    warning: (message: string) => toast.warning(message),
  };
};

// Export standalone functions for use outside of components
export const showSuccessToast = (message: string) => toast.success(message);
export const showErrorToast = (message: string) => toast.error(message);
export const showInfoToast = (message: string) => toast.info(message);
export const showWarningToast = (message: string) => toast.warning(message);

